<div class="generic__pagination">
    @if (showPaginationCount()) {
        <span class="body-1"> Showing {{ _displayedCount() }} of {{ totalCount() }} </span>
    }
    @if (displayedCount() < totalCount()) {
        <button
            mat-stroked-button
            class="generic__pagination-action"
            [disabled]="isLoading()"
            (click)="loadMore.emit()"
        >
            See more
        </button>
    }
</div>
